module.exports = __webpack_public_path__ + "img/order.38be4ccd.png";